'use client';

import React, { useEffect } from "react";

interface DataLayerTrackerProps {
    dataLayer: Record<string, any>;
}

/**
 * Tiny client island that pushes dataLayer object to window on mount.
 * Renders nothing visible.
 */
const DataLayerTracker: React.FC<DataLayerTrackerProps> = ({ dataLayer }) => {
    useEffect(() => {
        if (dataLayer) {
            //@ts-ignore
            window.pageViewDataLayerObj = dataLayer;
        }
    }, [dataLayer]);

    return null;
};

export default DataLayerTracker;
